import { StockOverviewListSortModifierType } from "@sellar-io/api-v2/types";
import { SortType } from "../../lists/types";

export type StockOverviewSortType =
  | "parent_name_asc"
  | "parent_name_desc"
  | "created_asc"
  | "created_desc"
  | "sku_asc"
  | "sku_desc"
  | "available_stock_asc"
  | "available_stock_desc";

export const StockOverviewSortValues: SortType<
  StockOverviewListSortModifierType,
  StockOverviewSortType
> = {
  created_desc: {
    key: "created_desc",
    name: "Most recently added",
    mutation: {
      type: "createdAt",
      direction: "desc",
    },
  },
  created_asc: {
    key: "created_asc",
    name: "Least recently added",
    mutation: {
      type: "createdAt",
      direction: "asc",
    },
  },
  parent_name_asc: {
    key: "parent_name_asc",
    name: "Name (A-Z)",
    mutation: {
      type: "parentName",
      direction: "asc",
    },
  },
  parent_name_desc: {
    key: "parent_name_desc",
    name: "Name (Z-A)",
    mutation: {
      type: "parentName",
      direction: "desc",
    },
  },
  sku_asc: {
    key: "sku_asc",
    name: "SKU (asc)",
    mutation: {
      type: "sku",
      direction: "asc",
    },
  },
  sku_desc: {
    key: "sku_desc",
    name: "SKU (desc)",
    mutation: {
      type: "sku",
      direction: "desc",
    },
  },
  available_stock_asc: {
    key: "available_stock_asc",
    name: "Available stock (asc)",
    mutation: {
      type: "availableStock",
      direction: "asc",
    },
  },
  available_stock_desc: {
    key: "available_stock_desc",
    name: "Available stock (desc)",
    mutation: {
      type: "availableStock",
      direction: "desc",
    },
  },
};
